<template>
  <div id="container" class="col-12">
    <div id="TituloDetalleDeDocumento_div">
      <h2 class="label-black" style="margin-bottom: 0px;">Reporte Anual de Interinatos</h2>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
              <div class="row" style="margin-top:30px;">
                <div class="col-3">
                  <label class="label-black" for="">Periodo</label>
                  <input type="date"
                        class="form-control"
                        v-model="fechaInicial"
                        v-on:keyup.enter="buscarEvaluados" />
                </div>
                <div class="col-3">
                  <label class="label-black" for="">‎</label>
                  <input type="date"
                        class="form-control"
                        v-model="fechaFinal"
                        v-on:keyup.enter="buscarEvaluados" />
                </div>
                <div class="col-3">
                  <label class="label-black" for="">Tipo de Contrato</label>
                  <select class="form-control" v-model="tipoContratoIdAux">
                    <option value="0">Todos</option>
                    <option value="1" selected>Interinato</option>
                    <option value="2">De Base</option>
                  </select>
                </div>
                <div class="col-3">
                  <label class="label-black" for="">‎</label>
                  <input type="button"
                        value="Buscar"
                        v-on:click="buscarEvaluados"
                        class="form-control btn-sm btn-custom" />
                </div>
              </div>
              <div class="row" style="margin-top:10px;">
                <div class="col-3">
                  <label class="label-black" for="">Nombre(s) y/o Apellidos</label>
                  <input type="text"
                        class="form-control"
                        placeholder="Nombre"
                        v-model="nombreBusqueda"
                        v-on:keyup.enter="buscarEvaluados" />
                </div>
                <div class="col-3">
                  <label class="label-black" for="">No. de Nómina</label>
                  <input type="text"
                        class="form-control"
                        placeholder="No. de Nómina"
                        v-model="numeroNominaBusqueda"
                        v-on:keyup.enter="buscarEvaluados" />
                </div>
              </div>
              <div class="row" style="margin-top:30px;">
                <div class="col-9"></div>
                <div class="col-3 padding-0">
                  <input type="button" v-if="infoPersonas.length > 0" class="form-control btn-sm btn-secondary" @click="generarReporte" value="Generar Reporte">
                </div>
              </div>
              <div class="row">
                <div class="col-12"><hr /></div>
              </div>
              <div class="row table-responsive">
                
                  <table class="table table-striped table-light table-hover table-sm"
                        id="tablaPersonal">
                    <thead class="thead-custom">
                      <tr>
                        <th>Número de Nómina</th>
                        <th>Nombre</th>
                        <th>Puesto</th>                  
                      </tr>
                    </thead>
                    <tbody class="text-dark">
                      <template v-for="infoPersona in infoPersonas">
                        <tr>
                          <td>{{ infoPersona.NumeroNomina }}</td>
                          <td>{{ infoPersona.NombreCompleto }}</td>
                          <td>{{ infoPersona.Puesto }} - {{ infoPersona.Departamento }} - {{ infoPersona.Seccion }}</td>
                          
                        </tr>
                        <tr>
                          <td><b>Antiguedad: </b>
                              <span v-if="infoPersona.AntiguedadAno > 0">{{infoPersona.AntiguedadAno}} <span v-if="infoPersona.AntiguedadAno > 1">Años</span><span v-else>Año</span></span>                        
                              <span v-if="infoPersona.AntiguedadMes > 0">{{infoPersona.AntiguedadMes}} <span v-if="infoPersona.AntiguedadMes > 1">Meses</span><span v-else>Mes</span></span>
                              <span v-if="infoPersona.AntiguedadDia > 0">{{infoPersona.AntiguedadDia}} <span v-if="infoPersona.AntiguedadDia > 1">Dias</span><span v-else>Dia</span></span>
                            </td>
                          <td>
                            <b>Historial Laboral: </b>
                            <ul>
                              <li v-for="registro in infoPersona.HistorialLaboral">
                                <span>{{registro.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre}} / </span>
                                <span v-if="registro.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento != null">{{registro.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre}} / </span>
                                <span v-else>Sin Departamento / </span>
                                <span>{{registro.EstructuraOrganica.Puesto.Nombre}}</span>
                                <span>({{registro.Periodo}}) </span>
                              </li>
                            </ul>
                          </td>
                          <td>
                            <b>Historial de Evaluaciones: </b>
                            <ul>
                              <li v-for="evaluacion in infoPersona.Evaluaciones">
                                <span><b>Periodo: </b>{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</span><br />
                                <span><b>Resultado: </b>{{promedio(evaluacion.ResultadoCategorias)}}</span>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              <!-- <div class="row table-responsive">
                
                  <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                      <tr>
                        <th rowspan="2">Nombre</th>
                        <th rowspan="2">Antiguedad</th>
                        <th rowspan="2">Juzgado/Área</th>
                        <th rowspan="2">Puesto</th>
                        <th rowspan="2">Fecha de Ingreso al Puesto</th>
                        <th rowspan="2">Persona a Quien Cubre</th>
                        <th rowspan="2">Periodo Evaluado</th>
                        <th colspan="5">Competencias</th>                  
                        <th rowspan="2">Resultado</th>
                        <th rowspan="2">Comentarios</th>
                      </tr>
                      <tr>
                        <th>IntraPersonal</th>
                        <th>Interpersonal</th>
                        <th>Desarrollo de Tareas</th>
                        <th>Entorno</th>
                        <th>Áreas de Oportunidad</th>
                      </tr>
                    </thead>
                    <tbody class="text-dark"></tbody></table>
              </div> -->
        </div>
      </div>
    </div>

    <!-- <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:30px;">
          <div class="col-3">
            <label for="">Periodo</label>
            <input type="date"
                   class="form-control"
                   v-model="fechaInicial"
                   v-on:keyup.enter="buscarEvaluados" />
          </div>
          <div class="col-3">
            <label for="">‎</label>
            <input type="date"
                   class="form-control"
                   v-model="fechaFinal"
                   v-on:keyup.enter="buscarEvaluados" />
          </div>
          <div class="col-3">
            <label for="">Tipo de Contrato</label>
            <select class="form-control" v-model="tipoContratoIdAux">
              <option value="0">Todos</option>
              <option value="1" selected>Interinato</option>
              <option value="2">De Base</option>
            </select>
          </div>
          <div class="col-2">
            <label for="">‎</label>
            <input type="button"
                   value="Buscar"
                   v-on:click="buscarEvaluados"
                   class="form-control" />
          </div>
        </div>
        <div class="row" style="margin-top:10px;">
          <div class="col-3">
            <label for="">Búsqueda</label>
            <input type="text"
                   class="form-control"
                   placeholder="Nombre"
                   v-model="nombreBusqueda"
                   v-on:keyup.enter="buscarEvaluados" />
          </div>
          <div class="col-3">
            <label for="">No. de Nómina</label>
            <input type="text"
                   class="form-control"
                   placeholder="No. de Nómina"
                   v-model="numeroNominaBusqueda"
                   v-on:keyup.enter="buscarEvaluados" />
          </div>
        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-8"></div>
          <div class="col-3 padding-0">
            <input type="button" v-if="infoPersonas.length > 0" class="form-control" @click="generarReporte" value="Generar Reporte">
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-light table-hover"
                   id="tablaPersonal">
              <thead class="thead-custom">
                <tr>
                  <th>Número de Nómina</th>
                  <th>Nombre</th>
                  <th>Puesto</th>                  
                </tr>
              </thead>
              <tbody class="text-dark">
                <template v-for="infoPersona in infoPersonas">
                  <tr>
                    <td>{{ infoPersona.NumeroNomina }}</td>
                    <td>{{ infoPersona.NombreCompleto }}</td>
                    <td>{{ infoPersona.Puesto }} - {{ infoPersona.Departamento }} - {{ infoPersona.Seccion }}</td>
                    
                  </tr>
                  <tr>
                    <td><b>Antiguedad: </b>
                        <span v-if="infoPersona.AntiguedadAno > 0">{{infoPersona.AntiguedadAno}} <span v-if="infoPersona.AntiguedadAno > 1">Años</span><span v-else>Año</span></span>                        
                        <span v-if="infoPersona.AntiguedadMes > 0">{{infoPersona.AntiguedadMes}} <span v-if="infoPersona.AntiguedadMes > 1">Meses</span><span v-else>Mes</span></span>
                        <span v-if="infoPersona.AntiguedadDia > 0">{{infoPersona.AntiguedadDia}} <span v-if="infoPersona.AntiguedadDia > 1">Dias</span><span v-else>Dia</span></span>
                      </td>
                    <td>
                      <b>Historial Laboral: </b>
                      <ul>
                        <li v-for="registro in infoPersona.HistorialLaboral">
                          <span>{{registro.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre}} / </span>
                          <span v-if="registro.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento != null">{{registro.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre}} / </span>
                          <span v-else>Sin Departamento / </span>
                          <span>{{registro.EstructuraOrganica.Puesto.Nombre}}</span>
                          <span>({{registro.Periodo}}) </span>
                        </li>
                      </ul>
                    </td>
                    <td>
                      <b>Historial de Evaluaciones: </b>
                      <ul>
                        <li v-for="evaluacion in infoPersona.Evaluaciones">
                          <span><b>Periodo: </b>{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</span><br />
                          <span><b>Resultado: </b>{{promedio(evaluacion.ResultadoCategorias)}}</span>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-light table-hover">
              <thead class="thead-custom">
                <tr>
                  <th rowspan="2">Nombre</th>
                  <th rowspan="2">Antiguedad</th>
                  <th rowspan="2">Juzgado/Área</th>
                  <th rowspan="2">Puesto</th>
                  <th rowspan="2">Fecha de Ingreso al Puesto</th>
                  <th rowspan="2">Persona a Quien Cubre</th>
                  <th rowspan="2">Periodo Evaluado</th>
                  <th colspan="5">Competencias</th>                  
                  <th rowspan="2">Resultado</th>
                  <th rowspan="2">Comentarios</th>
                </tr>
                <tr>
                  <th>IntraPersonal</th>
                  <th>Interpersonal</th>
                  <th>Desarrollo de Tareas</th>
                  <th>Entorno</th>
                  <th>Áreas de Oportunidad</th>
                </tr>
              </thead>
              <tbody class="text-dark"></tbody></table>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";

export default {
  data() {
    return {
      enumeraciones,
      tipoContratoIdAux: 1,
      nombreBusqueda: "", //Filtro de busqueda de nombre
      numeroNominaBusqueda: "", //Filtro de busqueda de número de nómina      
      infoPersonas: [],      
      comboAreaId: null,
      comboAreaNombre: null,
      fechaInicial: null,
      fechaFinal: null,
      datosLocales: [
        {
          Id: 0,
          key: "area",
          valor: { Id: -1, nombre: null }
        }
      ]
    };
  },
  components: {
    C001Area: catalogos.PJ.C001Area
  },
  methods: {
    CambioAreaBusqueda(datos) {
      this.comboAreaId = parseInt(datos.target.value);
      this.comboAreaNombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    //busca a traves de axios el personal almacenado en base de datos
    buscarEvaluados: function(event) {
      if (this.numeroNominaBusqueda != "" && isNaN(this.numeroNominaBusqueda)) {
        $("#alertaNumeroNomina").show();
        return;
      }
      var peticion = {
        //Carga los valores para enviar la petición de busqueda
        esPrueba: false,
        nombreBusqueda: this.nombreBusqueda,
        numeroNominaBusqueda: parseInt(this.numeroNominaBusqueda, 10),
        tipoContratoId: this.tipoContratoId,
        AreaId: -1,
        //AreaId: this.datosLocales[0].valor.Id,
        FechaInicio: this.fechaInicial,
        FechaFin: this.fechaFinal,
        baneados: [],
        verInactivos: true
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIAP.funcion.GetPersonasReportePersonal,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            $("#alertaNumeroNomina").hide();
            this.infoPersonas = response.data.InfoPersonas; //transifiere los datos necesarios
            /*const rows = [];
            this.infoPersonas.forEach(function (persona) {
              persona.Contrasena = persona.Contrasena.split('#').join('gato');
              rows.push([persona.NombreCompleto, persona.PersonaId, persona.Puesto, persona.Seccion, persona.Departamento, persona.Usuario, persona.Contrasena]);

            });
            let csvContent = "data:text/csv;charset=windows-1252,"
              + rows.map(e => e.join(",")).join("\n");
            var encodedUri = encodeURI(csvContent);
            window.open(encodedUri);
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "my_data.csv");
            document.body.appendChild(link); // Required for FF

            link.click();*/
            this.mostrarTabla = true;
            this.$nextTick(() => {
              PaginarTabla("tablaPersonal", 20);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    
    getValorEntidad(respuestaHijo) {
      this.datosLocales[0].valor = {
        Id: parseInt(respuestaHijo.target.value),
        nombre:
          respuestaHijo.target.options[respuestaHijo.target.selectedIndex].text
      };
    },
    promedio: function (resultados) {
        var x;
        var suma = 0;
        var contador = 0;
        for (x of resultados) {
          if (x != null) {
            suma += parseFloat(x);
            contador++;
          }
        }
        return (Math.round(suma / contador * 100) / 100).toFixed(2);
    },
    generarReporte: function () {
      var popupWin = window.open('', '_blank', 'width=720,height=600,location=no,left=100px');
        popupWin.document.open();
        popupWin.document.write('<html><head><title>Reporte de Personal</title>');
        popupWin.document.write('<style>  tr.page-break  { display: block; page-break-after: always; }</style>');
        popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
        popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
        popupWin.document.write('</head><body >')
        popupWin.document.write('<h2>Reporte de Personal</h2>')
        
        popupWin.document.write('<table class="table table-striped table-light table-hover" id="tablaEvaluaciones">')
        var resultados = document.getElementById('tablaPersonal').innerHTML;
        //console.log(resultados.indexOf('style="display: none; opacity: 0;"'));
        resultados = resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        resultados = resultados.split('style="opacity: 0; display: none;"').join('style="opacity: 1; display: table-row;"');
        //console.log(resultados.indexOf('class="visible-element"'));
        resultados = resultados.split('class="visible-element"').join('style="opacity: 0"');
        //resultados = resultados.split('class="hidden-element"').join('style="opacity: 1"');
        //resultados = resultados.split('</td></tr>').join('</td></tr><tr><th>Nombre</th><th>Resultado</th><th>Intrapersonal</th><th>InterPersonal</th><th>Desarrollo de Tareas</th><th>Entorno</th><th>Gerencia</th><th>Áreas de Oportunidad</th><th class="visible-element">Acciones</th></tr>');
        //resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        //console.log(resultados);
        popupWin.document.write(resultados);
        popupWin.document.write('</table>');
        popupWin.document.write('</body></html>');
        /*var css = '@page { size: landscape; }',
          head = popupWin.document.head || document.getElementsByTagName('head')[0],
          style = popupWin.document.createElement('style');

        style.type = 'text/css';
        style.media = 'print';

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(popupWin.document.createTextNode(css));
        }

        head.appendChild(style);*/
        setTimeout(function () { popupWin.print(); }, 1000)
        popupWin.document.close();
        popupWin.focus();

    }
    },
    computed: {
      tipoContratoId: function () {
        return (this.tipoContratoIdAux == 0)? null : this.tipoContratoIdAux;
      }
    },
    mounted: function () {
      var date = new Date();
    this.fechaInicial = new Date(date.getFullYear(), 0, 1).toISOString().split('T')[0];
      this.fechaFinal = new Date(date.getFullYear(), 11, 31).toISOString().split('T')[0];
    $("#alertaNumeroNomina").hide(); //Oculta la alerta de error en Número de Nómina (para busqueda) al montar el componente
    //this.buscarEvaluados();
  }
};
</script>

<style scoped>
  th {
    vertical-align: middle !important;
    text-align: center;
  }
  .thead-custom {
  background-color: #004746;
  color: white;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/ReporteAnualInterinatos.vue